import reporttemplate from './reporttemplate/model';
import reportrecord from './reportrecord/model';

export default [
    ...Object.values(reporttemplate.sagas),
    ...Object.values(reportrecord.sagas),
];